export const PRICING_FAQS = [
  {
    answer:
      'A soundcast is the basic selling unit of your audio. A soundcast = an audiobook, a podcast, an audio course, or an album, depending on your use case. A soundcasts can consist of any number of audio tracks.',
    question: 'What is a soundcast?',
  },
  {
    answer:
      'An (audio) track is a chapter in an audiobook, an episode in a podcast, a lesson in an audio course, a song in an album, depending on your use case.',
    question: 'What is an audio track?',
  },
  {
    answer:
      'Yes. We have sales pages built-in for all your soundcasts. But you don’t have to use them. Each soundcast has a checkout page. You can link that to a “Buy” button on your own site. On the Pro plan and above, you can also integrate us with your own payment processing. To know more about how to integrate Soundwise into your own online sales process, check out <a href="https://support.mysoundwise.com/article/wca64y8cx6-how-to-integrate-soundwise-into-your-existing-online-sales-process" target="_blank">this help doc</a>.',
    question: 'Can I sell audio from my own website and use my own sales page?',
  },
  {
    answer:
      'The Soundwise app provides a secure container for delivering your paid audio. This way we make sure you have total access control over your audio-- no unauthorized person can get them and nobody can copy or move your files. The level of security, control, and tracking that we provide is not possible with other solutions that deliver your paid audio through 3rd-party podcast apps. In the long run we think ours is a more sensible solution for distributing paid answer. It also makes answer management significantly easier when you have a large audio library.',
    question: 'Why do my audience have to download an app?',
  },
  {
    answer: 'Absolutely. They can use our web portal to listen from their web browser.',
    question: 'Can my audience listen from their computer, too?',
  },
  {
    answer:
      'Of course. Many of our users publish free soundcasts for lead generation and for building their email lists.',
    question: 'Can I publish free soundcasts?',
  },
  {
    answer:
      'You get listener names and email addresses on all plans. On the Plus plan and above, you also get detailed listening analytics report down to each listener.',
    question: 'What listener information do I get?',
  },
  {
    answer:
      'A bundle is a group of soundcasts. You can sell your listeners a bundle as well as individual soundcasts in the bundle. There are many use cases for a bundle. For example, you can price the bundle at a discount relative to the total price of the individual soundcasts included, as a promotional package. On the Plus plan and above, you can also add all your soundcasts to the bundle and charge subscription fees for your entire audio library.',
    question: 'What is a bundle?',
  },
  {
    answer:
      'A private soundcast is a soundcast that doesn’t have a landing page and doesn’t show up in search results either on the web or in our mobile app. It’s an ideal way for creating, for example, private training materials within your organization or for private clients, advance reviewer copy for yet-to-be-published audiobooks, private podcasts, and private memberships. On some of our publisher plans, there are limits in terms of how many total listeners you can enroll to your private soundcasts. Please check our plan & pricing table for details.',
    question: 'What is a private soundcast?',
  },
  {
    answer:
      'Immediately after someone makes a purchase, the money will be in your Stripe account. You can move the money to your bank account from Stripe anytime.',
    question: 'How soon do I get my sales proceeds?',
  },
  {
    answer:
      'Anybody who has the Soundwise app installed can search and find your soundcasts on the app. However, we do not proactively present other publishers’ soundcasts to your listeners, and vice versa. We aim to provide an exclusive environment for your listener community, and allow your listeners to enjoy your soundcasts with minimum distraction. We do showcase your other soundcasts on the app to the listeners who have already signed up for one or more of your own soundcasts, which help increase the lifetime value per customer for your business.',
    question: 'Do you promote audio to listeners of other publishers on Soundwise?',
  },
];
